import { render, staticRenderFns } from "./index-cool.vue?vue&type=template&id=91fa71f8&scoped=true"
import script from "./index-cool.vue?vue&type=script&lang=js"
export * from "./index-cool.vue?vue&type=script&lang=js"
import style0 from "./index-cool.vue?vue&type=style&index=0&id=91fa71f8&lang=scss&scoped=true"
import style1 from "./index-cool.vue?vue&type=style&index=1&id=91fa71f8&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91fa71f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\yl\\yl-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91fa71f8')) {
      api.createRecord('91fa71f8', component.options)
    } else {
      api.reload('91fa71f8', component.options)
    }
    module.hot.accept("./index-cool.vue?vue&type=template&id=91fa71f8&scoped=true", function () {
      api.rerender('91fa71f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/feedback/index-cool.vue"
export default component.exports